import { render, staticRenderFns } from "./BaseActionFooter.vue?vue&type=template&id=a3087888"
import script from "./BaseActionFooter.vue?vue&type=script&lang=js"
export * from "./BaseActionFooter.vue?vue&type=script&lang=js"
import style0 from "./BaseActionFooter.vue?vue&type=style&index=0&id=a3087888&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports